import * as Yup from 'yup';

export const refDataPrivilegeSchema = Yup.object().shape({
    methodName: Yup.string()
        .trim()
        .max(255, 'Method name must not exceed 255 characters')
        .required('Method name is required'),
});
